import { render, staticRenderFns } from "./Presite.vue?vue&type=template&id=18ae4855&"
import script from "./Presite.vue?vue&type=script&lang=js&"
export * from "./Presite.vue?vue&type=script&lang=js&"
import style0 from "../scss/app.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports